import { FC, useEffect, useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import MyModal from '../MyModal';

interface ICreditNoteDialog {
  isOpened: boolean;
  handleClose: () => void;
  invoiceNumber: string;
  onConfirm: (issued: Date) => Promise<boolean>;
}

const CreditNoteDialog: FC<ICreditNoteDialog> = ({
  isOpened,
  handleClose,
  invoiceNumber,
  onConfirm,
}) => {
  const [issued, setIssued] = useState<Date | null>(new Date());
  const [submitting, setSubmitting] = useState<boolean>(false);

  useEffect(() => {
    if (isOpened) setIssued(new Date());
  }, [isOpened]);

  const isValidDate = !!issued && !Number.isNaN(issued.getTime());

  const handleConfirm = async () => {
    if (!isValidDate) return;
    setSubmitting(true);
    const ok = await onConfirm(issued);
    setSubmitting(false);
    if (ok) handleClose();
  };

  return (
    <MyModal isOpened={isOpened} handleClose={handleClose}>
      <Stack direction="column" spacing={3}>
        <Typography variant="h6">Vystaviť dobropis k faktúre {invoiceNumber}</Typography>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Dátum dobropisu"
            value={issued}
            onChange={(value) => setIssued(value ? new Date(value) : null)}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <Typography variant="body2" color="text.secondary">
          Pohľadávka sa zároveň označí ako zrušená. Dobropis dostane ďalšie číslo v rade účtovného
          roka faktúry.
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="outlined" onClick={handleClose} disabled={submitting}>
            Zrušiť
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleConfirm}
            disabled={!isValidDate || submitting}
          >
            Vystaviť dobropis
          </Button>
        </Stack>
      </Stack>
    </MyModal>
  );
};

export default CreditNoteDialog;
